<div class="card">
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="customerService.customerSubscriptionItemList.value"
		[(selection)]="subscriptionRecordsSelected"
		dataKey="sk"
		[scrollable]="true"
		[rows]="100"
		selectionMode="multiple"
		scrollHeight="700px"
		[virtualRowHeight]="40"
		[virtualScroll]="true"
		[globalFilterFields]="app.keys(customerService.customerSubscriptionItemList.value)"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-fill">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
				<div class="d-flex ms-2 justify-content-between">
					<p-button
						[disabled]="!subscriptionRecordsSelected || subscriptionRecordsSelected.length === 0"
						pRipple
						styleClass="p-button-raised p-button-info m-2"
						(click)="onBulkEdit()"
					>
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'tools']" size="lg" class="ms-1 me-2"></fa-icon>
								Edit selected
							</div>
						</ng-template>
					</p-button>
					<p-button
						[disabled]="!subscriptionRecordsSelected || subscriptionRecordsSelected.length === 0"
						pRipple
						styleClass="p-button-raised p-button-success m-2"
						(click)="onRunItemsNow()"
					>
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">
								<fa-icon [icon]="['far', 'running']" size="lg" class="ms-1 me-2"></fa-icon>
								Run selected now
							</div>
						</ng-template>
					</p-button>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th style="width: 10px" pSortableColumn="inactive">
					<p-tableHeaderCheckbox class="me-4"></p-tableHeaderCheckbox>
					Active
					<p-sortIcon field="inactive"></p-sortIcon>
				</th>

				<th pSortableColumn="customerDto.lastName">Customer <p-sortIcon field="customerDto.lastName"></p-sortIcon></th>
				<th pSortableColumn="ooMenuItem.name">Item <p-sortIcon field="ooMenuItem.name"></p-sortIcon></th>
				<th pSortableColumn="frequencyDisplayName">Frequency <p-sortIcon field="frequencyDisplayName"></p-sortIcon></th>
				<th pSortableColumn="nextBillDateDate">Next billing date <p-sortIcon field="nextBillDateDate"></p-sortIcon></th>
				<th pSortableColumn="totalBilled">Qty billed <p-sortIcon field="totalBilled"></p-sortIcon></th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td>
					<p-tableCheckbox [value]="rec" class="d-flex my-auto me-4"></p-tableCheckbox>
					<p-inputSwitch [(ngModel)]="!rec.inactive" styleClass="my-auto" [disabled]="true"></p-inputSwitch>
				</td>
				<td (click)="subscriptionRecordSelected = rec">
					<span class="p-column-title">Customer</span>
					{{ app.references.toTitleCase(rec.customerDto?.lastName) }}, {{ app.references.toTitleCase(rec.customerDto?.firstName) }}
				</td>
				<td (click)="subscriptionRecordSelected = rec">
					<span class="p-column-title">Item</span>
					{{ rec.ooMenuItem.name }}
				</td>
				<td (click)="subscriptionRecordSelected = rec">
					{{ rec.frequencyDisplayName }}
				</td>
				<td (click)="subscriptionRecordSelected = rec">
					{{ app.moment.unix(rec.nextBillDate).format("l LT") }}
				</td>
				<td (click)="subscriptionRecordSelected = rec">
					{{ rec.totalBilled }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<app-subscription-record-view
	*ngIf="bulkEdit || subscriptionRecordSelected"
	[(bulkEdit)]="bulkEdit"
	[(subscriptionItem)]="subscriptionRecordSelected"
	[(subscriptionRecordsSelected)]="subscriptionRecordsSelected"
></app-subscription-record-view>
